// extracted by mini-css-extract-plugin
export default {"title":"title--2eW9","filled":"filled--5sp9","diff":"diff--dnZ3"};